import React, { useState } from 'react';
import { Mail, Phone, MapPin, MessageCircle, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error('Please fill in the required fields'); return; }
    setSending(true);
    try { const { data } = await api.post('/contact', form); toast.success(data.message); setForm({ name: '', email: '', phone: '', subject: '', message: '' }); }
    catch { toast.error('Could not send message'); } finally { setSending(false); }
  };
  const field = 'w-full rounded-lg border border-border px-3 py-2.5 text-sm outline-none focus:border-[hsl(var(--gaze-gold))]';
  return (
    <div className="container-gaze py-10">
      <div className="grid gap-10 lg:grid-cols-2">
        <div>
          <p className="eyebrow mb-2">We'd love to hear from you</p>
          <h1 className="font-display text-4xl">Get in touch</h1>
          <p className="mt-3 max-w-md text-sm text-muted-foreground">Questions about a product, an order, or interior styling? Our team is here to help.</p>
          <div className="mt-8 space-y-4">
            {[
              [Mail, 'Email', 'connect@gazedecor.in', 'mailto:connect@gazedecor.in'],
              [Phone, 'Phone', '+91 70276 25678', 'tel:+917027625678'],
              [MessageCircle, 'WhatsApp', 'Chat with us', 'https://wa.me/917027625678'],
              [MapPin, 'Studio', 'Mohali, Punjab', 'https://maps.app.goo.gl/ZWV56N9h1L3iCA2Z6']
            ].map(([Icon, t, v, href]) => (
              <a
                key={t}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="flex items-center gap-3 group"
              >
                <div className="grid h-11 w-11 place-items-center rounded-full bg-[hsl(var(--gaze-gold)/.10)] text-[hsl(var(--gaze-gold))]">
                  <Icon size={18} />
                </div>

                <div>
                  <p className="font-medium group-hover:text-[hsl(var(--gaze-gold))] transition-colors">
                    {t}
                  </p>
                  <p className="text-sm text-muted-foreground group-hover:text-foreground transition-colors">
                    {v}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
